import { useNavigate } from "react-router-dom";
import { useCustomerFormContext } from "../Context/CustomerFormContext";

const useCustomerForm = () => {
  const { formDatas, handleInputChange } = useCustomerFormContext();
  const navigate = useNavigate();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log(formDatas); 
    navigate("/Customeractivepage2");
  };

  return {
    formDatas,
    handleInputChange,
    handleFormSubmit
  };
};

export default useCustomerForm;




